// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content-box[data-v-c89c0142] {\n  position: relative;\n}\nbutton[data-v-c89c0142] {\n  position: absolute;\n  top: 1.25rem;\n  right: 2.25rem;\n}\n@media (max-width: 450px) {\nbutton[data-v-c89c0142] {\n    position: relative;\n    top: 0;\n    right: 0;\n    margin-bottom: 0.5rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
